var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.088 15.526c2.02-2.907 6.072-3.113 7.603-3.178h.052a11.351 11.351 0 0 1 3.677.586c1.041.292 2.406.65 4.489 1.084 2.646.342 5.322.342 7.968 0a17.521 17.521 0 0 1-.719-3.503c-.385-3.764.167-6.508 1.688-8.265a6.793 6.793 0 0 1 2.37-1.712 6.554 6.554 0 0 1 2.838-.534h.104c4.53 0 6.864 6.237 7.197 8.537.095.755.127 1.517.094 2.277 0 1.486 0 2.907 1.843 5.792a8.317 8.317 0 0 1 6.354.933c2.75 1.768 4.166 5.228 4.343 10.294.209 8.189-2.666 14.436-7.29 15.911a6.08 6.08 0 0 1-2.986.183 6.203 6.203 0 0 1-2.733-1.267c-1.927 1.214-4.718 1.909-8.728 1.084-1.448 2.17-3.49 4.252-6.78 4.252a8.886 8.886 0 0 1-1.647-.163c-3.583-.661-4.718-2.278-5.666-4.49a8.326 8.326 0 0 1-3.364-3.048 6.414 6.414 0 0 1-.865-4.338 12.087 12.087 0 0 1-2.27-4.339 9.176 9.176 0 0 1-.323-2.907 10.263 10.263 0 0 1-4.997-2.58 10.907 10.907 0 0 1-3.002-4.893 6.627 6.627 0 0 1-.282-2.952c.13-.993.484-1.94 1.032-2.764z",
    fill: "#F4F2F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.438 29.019s2.708-3.775-1.708-9.925c-4.01-5.597-2.656-7.69-3.02-10.196-.261-1.746-2.084-6.16-4.553-6.106-2.645 0-4.905 1.247-4.28 7.365.137 1.73.617 3.41 1.41 4.938a12.456 12.456 0 0 0 3.194 3.934",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.98 16.263s-7.853 1.41-12.561.532c-4.708-.879-5.927-1.67-7.551-1.584-1.625.087-7.23.293-5.875 5.239 1.354 4.946 6.864 6.508 10.343 5.423a10.755 10.755 0 0 1 5.812-.455M27.93 21.296s.187 8.916 9.144 9.328M42.574 32.63s-1.041 3.938-3.593 4.828",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.897 33.596s.083 10.445-11.77 6.899",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.293 19.864s8.728-4.338 9.04 7.962c.313 12.3-6.728 16.421-10.103 10.846M30.855 31.622s-2.082-.12-2.926 1.008M14.981 27.966s8.24-7.115 9.968.152c1.73 7.268-3.625 4.469-5.135 4.707-1.51.24-4.937 1.248-5.593 2.007-.656.76-5.322-5.26-1.885-8.753",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.221 31.416s3.125 2.983.854 4.664c-2.27 1.681-8.03 4.827-8.884 4.903-.854.076-5.208-2.365-2.969-6.15",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.46 35.711s2.78 2.55 1.155 5.424c-1.624 2.874-3.28 4.457-6.249 3.893-2.968-.564-3.125-1.648-4.166-4.024",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBack);
export default __webpack_public_path__ + "static/media/main-back.051befed799907d055e7f87b7eefa603.svg";
export { ForwardRef as ReactComponent };